export default __webpack_public_path__ + "static/media/G0670.34I-26408_-16223_0.1666266360000.30cfde14.jpg";